import PropTypes from 'prop-types';

import React, { Component, Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import { Route, withRouter } from 'react-router-dom';
import {
  fetchDispatchIDs,
  fetchManyResources,
  fetchResourcesByCurrentDispatch
} from '../../esri/mapHub';

import MapContainer from '../MapContainer';
import DispatchHeader from './DispatchHeader';
import ResourceCategoryNav from './ResourceCategoryNav';

import DispatchContainer from './DispatchContainer';

import './styles/Dispatch.css';
import '../../typedefs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { resourceOperations } from '../../redux/resource';
import { configOperations } from '../../redux/config';
import DispatchSimpleTable from './DispatchSimpleTable';
import OverviewContainer from './OverviewContainer';


class CurrentDispatchPage extends Component {
  constructor(props) {
    super(props);
    const {
      match: {
        params: { id = 'IDBDC' }
      }
    } = props;
    this._isMounted = false;

    this.state = {
      currentDispatchID: id,
      dispatches: {},
      overheadAtIncident: {
        fieldName: 'Overhead',
        type: 'string'
      },
      overheadUnavailable: {
        fieldName: 'Overhead',
        type: 'string'
      },
      // overheadInvalid: {
      //   fieldName: 'Invalid Overhead',
      //   type: 'string'
      // },
      equipmentAtIncident: {
        fieldName: 'Equipment',
        type: 'string'
      },
      equipUnavailable: {
        fieldName: 'Equipment',
        type: 'string'
      },
      equipInvalid: {
        fieldName: 'Invalid Equipment',
        type: 'string'
      },
      aircraftAtIncident: {
        fieldName: 'Aircraft',
        type: 'string'
      },
      aircraftUnavailable: {
        fieldName: 'Aircraft',
        type: 'string'
      },
      crewsAtIncident: {
        fieldName: 'Crews',
        type: 'string'
      },
      crewsUnavailable: {
        fieldName: 'Crews',
        type: 'string'
      },
      groupsAtIncident: {
        fieldName: 'Overhead Groups',
        type: 'string'
      },
      groupsUnavailable: {
        fieldName: 'Overhead Groups',
        type: 'string'
      },
      resourceNumber: {
        fieldName: 'Total Number of Resources'
      },
      quarantinedOverhead: {
        fieldName: 'Quarantined Overhead',
        type: 'string'
      }
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.setDispatchIDs = this.setDispatchIDs.bind(this);
    this.setCurrentDispatchID = this.setCurrentDispatchID.bind(this);
    this.getResources = this.getResources.bind(this);
    if (this._isMounted) {
      fetchDispatchIDs()
        .then(this.setDispatchIDs)
        .then(this.getResources(this.props.resource.currentDispatchID));
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getResources(CurrentDispatch) {
    let unavailOverhead,
        quarantineOverhead,
        unavailEquip,
        invalidEquip,
        unavailAir,
        unavailCrews,
        unavailOG;
    let i, e, a, c, og;

    const searchOptions = {
      ...this.props.csvQueryManyOptions,
      baseQuery: `CurrentDispatchUnit = '${CurrentDispatch}'`,
      page: 0,
      returnGeometry: false
    };
    fetchManyResources(searchOptions).then(
      response => {
        const resources = response;
        const totalOverhead = Object.fromEntries(
          Object.entries(resources).filter(
            ([key, value]) => value.attributes.ResourceKind === 'Overhead'
          )
        );
        if (totalOverhead) {
          i = Object.keys(
            Object.entries(totalOverhead).filter(
              ([key, value]) =>
                value.attributes.OperationalStatus === 'At Incident'
            )
          ).length;
          unavailOverhead = Object.keys(
            Object.entries(totalOverhead).filter(
              ([key, value]) =>
                value.attributes.GeneralStatus === 'Unavailable'
            )
          ).length;
          quarantineOverhead = Object.keys(
            Object.entries(totalOverhead).filter(
              ([key, value]) =>
                value.attributes.IsQuarantined === 1
            )
          ).length;
        } else {
          i = 0;
          unavailOverhead = 0;
          quarantineOverhead = 0;
        }
        const totalEquip = Object.fromEntries(
          Object.entries(resources).filter(
            ([key, value]) => value.attributes.ResourceKind === 'Equipment'
          )
        );
        if (totalEquip) {
          e = Object.keys(
            Object.entries(totalEquip).filter(
              ([key, value]) =>
                value.attributes.OperationalStatus === 'At Incident'
            )
          ).length;
          unavailEquip = Object.keys(
            Object.entries(totalEquip).filter(
              ([key, value]) =>
                value.attributes.GeneralStatus === 'Unavailable'
            )
          ).length;
          invalidEquip = Object.keys(
            Object.entries(totalEquip).filter(
              ([key, value]) =>
                value.attributes.IsValid === 0
            )
          ).length;
        } else {
          e = 0;
          unavailEquip = 0;
          invalidEquip = 0;
        }
        const totalAir = Object.fromEntries(
          Object.entries(resources).filter(
            ([key, value]) => value.attributes.ResourceKind === 'Aircraft'
          )
        );
        if (totalAir) {
          a = Object.keys(
            Object.entries(totalAir).filter(
              ([key, value]) =>
                value.attributes.OperationalStatus === 'At Incident'
            )
          ).length;
          unavailAir = Object.keys(
            Object.entries(totalAir).filter(
              ([key, value]) =>
                value.attributes.GeneralStatus === 'Unavailable'
            )
          ).length;
        } else {
          a = 0;
          unavailAir = 0;
        }
        const totalCrews = Object.fromEntries(
          Object.entries(resources).filter(
            ([key, value]) => value.attributes.ResourceKind === 'Crews'
          )
        );
        if (totalCrews) {
          c = Object.keys(
            Object.entries(totalCrews).filter(
              ([key, value]) =>
                value.attributes.OperationalStatus === 'At Incident'
            )
          ).length;
          unavailCrews = Object.keys(
            Object.entries(totalCrews).filter(
              ([key, value]) =>
                value.attributes.GeneralStatus === 'Unavailable'
            )
          ).length;
        } else {
          c = 0;
          unavailCrews = 0;
        }
        const totalOG = Object.fromEntries(
          Object.entries(resources).filter(
            ([key, value]) => value.attributes.ResourceKind === 'Overhead Group'
          )
        );
        if (totalOG) {
          og = Object.keys(
            Object.entries(totalOG).filter(
              ([key, value]) =>
                value.attributes.OperationalStatus === 'At Incident'
            )
          ).length;
          unavailOG = Object.keys(
            Object.entries(totalOG).filter(
              ([key, value]) =>
                value.attributes.GeneralStatus === 'Unavailable'
            )
          ).length;
        } else {
          og = 0;
          unavailOG = 0;
        }
        if (this._isMounted) {
          this.setState({
            overheadAtIncident: {
              fieldName: 'Overhead',
              type: 'string',
              value: `${i} / ${Object.keys(totalOverhead).length}`
            },
            overheadUnavailable: {
              fieldName: 'Overhead',
              type: 'string',
              value: `${unavailOverhead} / ${Object.keys(totalOverhead).length}`
            },
            quarantinedOverhead: {
              fieldName: 'Quarantined Overhead',
              type: 'string',
              value: `${quarantineOverhead} / ${
                Object.keys(totalOverhead).length
              }`
            },
            equipmentAtIncident: {
              fieldName: 'Equipment',
              type: 'string',
              value: `${e} / ${Object.keys(totalEquip).length}`
            },
            equipUnavailable: {
              fieldName: 'Equipment',
              type: 'string',
              value: `${unavailEquip} / ${Object.keys(totalEquip).length}`
            },
            equipInvalid: {
              fieldName: 'Invalid Equipment',
              type: 'string',
              value: `${invalidEquip} / ${Object.keys(totalEquip).length}`
            },
            aircraftAtIncident: {
              fieldName: 'Aircraft',
              type: 'string',
              value: `${a} / ${Object.keys(totalAir).length}`
            },
            aircraftUnavailable: {
              fieldName: 'Aircraft',
              type: 'string',
              value: `${unavailAir} / ${Object.keys(totalAir).length}`
            },
            crewsAtIncident: {
              fieldName: 'Crews',
              type: 'string',
              value: `${c} / ${Object.keys(totalCrews).length}`
            },
            crewsUnavailable: {
              fieldName: 'Crews',
              type: 'string',
              value: `${unavailCrews} / ${Object.keys(totalCrews).length}`
            },
            groupsAtIncident: {
              fieldName: 'Overhead Groups',
              type: 'string',
              value: `${og} / ${Object.keys(totalOG).length}`
            },
            groupsUnavailable: {
              fieldName: 'Overhead Groups',
              type: 'string',
              value: `${unavailOG} / ${Object.keys(totalOG).length}`
            },
            resourceNumber: {
              fieldName: 'Total Number of Resources',
              type: 'string',
              value: resources.length
            }
          });
          if (!response) {
            this.setState({
              isValid: false,
              resourceNumber: {
                fieldName: 'Resource Number',
                type: 'string',
                value: 1
              }
            });
          }
        }

        // zoom to the features
        //
        /* / if (resources) {
            zoomToGeometry(response);
          } / */
      },
      error => {
        console.error(error);
        this.setState({ isValid: false });
      }
    );

  }

  setCurrentDispatchID({ target: { value: DISPATCH_ID } }) {
    const q = window.location.search;
    const {
      props: { history }
    } = this;

    history.push(`/dispatches/${DISPATCH_ID}/${q}`);
    this.setState({
      currentDispatchID: DISPATCH_ID
    });

    this.props.setDispatch(DISPATCH_ID);
    this.getResources(DISPATCH_ID);
  }

  /**
   * @func  setDispatchIDs
   * @desc
   *
   * @param {ResourceQueryResponse} response
   */
  setDispatchIDs({ features = [] }) {
    const DISPATCH_IDS = features.map(
      ({ attributes: { CurrentDispatchUnit } }) => CurrentDispatchUnit
    );
    const UNIQUE_DISPATCH_IDS = DISPATCH_IDS.reduce(
      this.reduceUniqueDispatchIDs,
      {}
    );

    this.setState({ dispatches: UNIQUE_DISPATCH_IDS });
  }

  /**
   * @func  convertDispatchesToOptions
   * @desc  Converts the dispatch dictionary to an array of objects with the
   *        dispatch ID and name.
   *
   * @param   {Object} dispatches
   * @return  {Array.<Object>}
   */
  convertDispatchesToOptions = dispatches => {
    const DISPATCH_KEYS = Object.keys(dispatches).sort();
    return DISPATCH_KEYS.map(key => ({ id: key, name: dispatches[key].name }));
  };

  /**
   * @func  reduceUniqueDispatchIDs
   * @desc  Reduces the array of the current dispatch IDs into an object where
   *        each key is a dispatch ID and the values are corresponding
   *        attributes.
   *
   * @param   {string} currDispatchID
   * @param   {Object} dispatches
   * @return  {Object}
   */
  reduceUniqueDispatchIDs = (dispatches, currDispatchID) => {
    if (!(currDispatchID in dispatches)) {
      dispatches[currDispatchID] = {
        name: currDispatchID,
        id: currDispatchID
      };
    }
    return dispatches;
  };

  render() {
    const { currentDispatchID, dispatches } = this.state;
    if (!(currentDispatchID in dispatches)) {
      return <Route to="/dispatches" />;
    }
    const { setCurrentDispatchID } = this;
    const disclaimerRow = [
      'NOTE: These Values Reflect Resources Integrated With IRWIN Only'
    ];
    const generalStatusRows = [
      this.state.overheadUnavailable,
      this.state.equipUnavailable,
      this.state.aircraftUnavailable,
      this.state.crewsUnavailable,
      this.state.groupsUnavailable
    ];
    const quarantinedRows = [
      this.state.quarantinedOverhead
    ];
    const quarEquip = [this.state.equipInvalid];

    const statsRows = [
      this.state.overheadAtIncident,
      this.state.equipmentAtIncident,
      this.state.aircraftAtIncident,
      this.state.crewsAtIncident,
      this.state.groupsAtIncident,
      this.state.resourceNumber

    ];
    const DISPATCH_OPTIONS = this.convertDispatchesToOptions(dispatches);

    return (
      <Fragment>
        <DispatchContainer>
          <Grid
            container
            style={{ flex: '1 0 200px', flexDirection: 'row', flexGrow: 1 }}
          >
            <Grid style={{ flex: '1 0', flexDirection: 'row' }}>
              <DispatchHeader
                dispatchOptions={DISPATCH_OPTIONS}
                currentDispatchID={this.props.resource.currentDispatchID}
                setCurrentDispatchID={setCurrentDispatchID}
              />
              <OverviewContainer>
                <Grid item s={14}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <DispatchSimpleTable
                        rows={statsRows}
                        title="Operational Status: 'At Incident'"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <DispatchSimpleTable
                        rows={generalStatusRows}
                        title="General Status: 'Unavailable'"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <DispatchSimpleTable
                        rows={quarantinedRows}
                        title="Quarantined Overhead"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <DispatchSimpleTable
                        rows={quarEquip}
                        title="Equipment: Invalid"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <h5 style={{ textAlign: 'center' }}>{disclaimerRow}</h5>
              </OverviewContainer>
            </Grid>

            <Grid
              item
              xs={3}
              className="map-col"
              style={{
                display: this.props.map.mapColumnVisible ? '' : 'none'
              }}
            >
              <MapContainer isDetailMap />
            </Grid>
          </Grid>
          <Grid container style={{ flex: '3', flexGrow: 4 }}>
            <Grid item xs={12}>
              <ResourceCategoryNav />
            </Grid>
          </Grid>
        </DispatchContainer>
      </Fragment>
    );
  }
}

CurrentDispatchPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  })
};

CurrentDispatchPage.defaultProps = {
  match: {
    params: {
      id: ''
    }
  }
};

const mapStateToProps = state => ({
  resources: state.resources,
  setFieldDefs: state.setFieldDefs,
  incidentHistory: state.incident.history,
  resource: {
    currentDispatchID: state.resource.currentDispatchID
  },
  map: state.map,
  env: state.config.env,
  csvQueryManyOptions: state.config.csvQueryManyOptions
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...resourceOperations,
      ...configOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CurrentDispatchPage)
);



// WEBPACK FOOTER //
// ./src/components/dispatches/CurrentDispatchPage.js